import React from 'react';
import GalleryManagementV2 from '@/features/gallery/containers/GalleryManagementV2';

export default function GalleryManagement() {
  return <GalleryManagementV2 />;
}
